export type UserStatus = 'available' | 'busy' | 'do_not_disturb' | 'away' | 'in_meeting' | 'offline' | 'traveling';

export interface UserPresence {
  id: string;
  user_id: string;
  status: UserStatus;
  status_message?: string;
  last_seen: string;
  is_active: boolean;
  activity_timeout?: string;
  created_at: string;
  updated_at: string;
  current_location?: string;
  available_until?: string;
  location_message?: string;
  notify_radius_km?: number;
  latitude?: number;
  longitude?: number;
}

export interface StatusOption {
  value: UserStatus;
  label: string;
  color: string;
  icon: string;
  description: string;
}

export const STATUS_OPTIONS: StatusOption[] = [
  {
    value: 'available',
    label: 'Disponible',
    color: 'text-green-600',
    icon: '🟢',
    description: 'Je peux être contacté'
  },
  {
    value: 'busy',
    label: 'Occupé',
    color: 'text-orange-600',
    icon: '🟠',
    description: 'Au travail, réponse différée'
  },
  {
    value: 'do_not_disturb',
    label: 'Ne pas déranger',
    color: 'text-red-600',
    icon: '🔴',
    description: 'Indisponible'
  },
  {
    value: 'in_meeting',
    label: 'En réunion',
    color: 'text-blue-600',
    icon: '🔵',
    description: 'En appel/meeting'
  },
  {
    value: 'away',
    label: 'Absent',
    color: 'text-gray-600',
    icon: '⚫',
    description: 'Hors ligne temporairement'
  },
  {
    value: 'offline',
    label: 'Hors ligne',
    color: 'text-gray-400',
    icon: '⚪',
    description: 'Non connecté'
  },
  {
    value: 'traveling',
    label: 'En déplacement',
    color: 'text-orange-600',
    icon: '🧳',
    description: 'Disponible pour rencontre'
  }
];

export const getStatusOption = (status: UserStatus): StatusOption => {
  return STATUS_OPTIONS.find(option => option.value === status) || STATUS_OPTIONS[STATUS_OPTIONS.length - 1];
};